import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { combineClasses } from "../../../utilities/combineClasses.js";
import InternalFlexBox_module from "./InternalFlexBox.module.js";
import { theme } from "../../../theme/index.js";
const InternalFlexBox = /*#__PURE__*/ forwardRef(({ as, style, className, children, testId, display, width, minWidth, maxWidth, height, minHeight, maxHeight, flexDirection, flexWrap, justifyContent, alignItems, alignContent, flexGrow, flexShrink, flexBasis, gap, alignSelf, overflow, overflowX, overflowY, ...props }, ref)=>{
    const As = as ?? 'div';
    const overFlowProps = null != overflow ? {
        overflow
    } : {
        overflowX,
        overflowY
    };
    return /*#__PURE__*/ jsx(As, {
        ref: ref,
        "data-testid": testId,
        className: combineClasses(InternalFlexBox_module.internalFlexBox, className),
        style: {
            display,
            width,
            minWidth,
            maxWidth,
            height,
            minHeight,
            maxHeight,
            flexDirection,
            flexWrap,
            justifyContent,
            alignItems,
            alignContent,
            flexGrow,
            flexShrink,
            flexBasis,
            gap: gap ? theme.spacing[gap] : void 0,
            alignSelf,
            ...overFlowProps,
            ...style
        },
        ...props,
        children: children
    });
});
InternalFlexBox.displayName = 'InternalFlexBox';
export { InternalFlexBox };
